import React from "react";
import classNames from "classnames/bind";

import { Radio } from "../Radio";

import styles from "./RadioGroup.module.css";
import { useStateManager } from "utils/useStateManager";

const cx = classNames.bind(styles);

type Props = {
  disabled?: boolean;
  label?: React.ReactNode;
  required?: boolean;
  name: string;
  value: string;
  onChange: React.ComponentProps<typeof Radio>["onChange"];
  items: {
    value: string;
    label: string;
  }[];
};

export const RadioGroup: React.FC<Props> = (props) => {
  const { linkInfo } = useStateManager();
  const isRequiredStarShow = linkInfo?.custom?.custom_показывать_звездочки_обязательности;

  return (
    <div className={cx("radioGroup")}>
      {props.label && (
        <span className={cx("label")}>
          {props.label}
          {props.required && isRequiredStarShow && <span className={cx("required")}>*</span>}
        </span>
      )}
      <div className={cx("items")}>
        {props.items.map((item, key) => (
          <Radio
            key={item.value}
            name={props.name}
            value={item.value}
            checked={item.value === props.value}
            disabled={props.disabled}
            onChange={props.onChange}
          >
            {item.label}
          </Radio>
        ))}
      </div>
    </div>
  )
};
